class StatusTagMapper {
    static STATUS_MAP = {
        draft: { label: 'Draft', color: 'gold', icon: 'edit' },
        ready: { label: 'Salvata-neprogramata', color: 'cyan', icon: 'check-circle' },
        programmed: { label: 'Programata', color: 'blue', icon: 'clock' },
        bidding_open: { label: 'In ofertare', color: 'processing', icon: 'sync' },
        offering: { label: 'In ofertare', color: 'processing', icon: 'sync' },
        bidding_closed: { label: 'Ofertare inchisa', color: 'warning', icon: 'stop' },
        offered: { label: 'Ofertata', color: 'geekblue', icon: 'file-done' },
        manual_processing: { label: 'Procesare manuala', color: 'purple', icon: 'tool' },
        archived: { label: 'Arhivata', color: 'default', icon: 'inbox' },
        pending: { label: 'In asteptare', color: 'default', icon: 'clock' },
        accepted: { label: 'Oferta acceptata', color: 'success', icon: 'check-circle' },
        rejected: { label: 'Oferta refuzata', color: 'error', icon: 'close-circle' },
        preapproved: { label: 'Preaprobat', color: 'processing', icon: 'safety' },
        bidding: { label: 'In ofertare', color: 'processing', icon: 'sync' },
        open: { label: 'Deschis', color: 'success', icon: 'unlock' },
        blocked: { label: 'Blocat', color: 'error', icon: 'lock' },
        purchased: { label: 'Achizitionat', color: 'success', icon: 'shopping' },
        not_purchased: { label: 'Neachizitionat', color: 'error', icon: 'close-circle' },
        necessary: { label: 'Necesar', color: 'blue', icon: 'tag' },
        necesar: { label: 'Necesar', color: 'blue', icon: 'tag' },
    };

    static normalizeStatus(status) {
        if (status === undefined || status === null) {
            return '';
        }

        return String(status).trim().toLowerCase();
    }

    static humanizeStatus(status) {
        const normalizedStatus = this.normalizeStatus(status);
        if (!normalizedStatus) {
            return 'Necunoscut';
        }

        return normalizedStatus
            .split('_')
            .map(token => token.charAt(0).toUpperCase() + token.slice(1))
            .join(' ');
    }

    static resolve(status) {
        const normalizedStatus = this.normalizeStatus(status);

        if (this.STATUS_MAP[normalizedStatus]) {
            return this.STATUS_MAP[normalizedStatus];
        }

        return {
            label: this.humanizeStatus(status),
            color: 'default',
            icon: 'question'
        };
    }
}

export default StatusTagMapper;
